import { IconTableOutline18 as Table } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const tableCommand: SlashCommandDefinition = {
	key: "table",
	title: "Table",
	icon: <Table strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.insertTable({ rows: 3, cols: 3, withHeaderRow: true })
			.run()
	},
	group: "blocks",
}
